import React from 'react';
import { Container, Tab, Button, Row, Tabs } from 'react-bootstrap';
import AppStoreSvg from "../component/ButtonComponents/appstore";
import PlayStoreSvg from "../component/ButtonComponents/playstore";


import "../../homepage/homepage.css";
import AnimatedWrapper from './AnimatedWrapper';

import { Links } from "../../Links";


function DownloadApp() {
  return (
    <Container fluid className="downloadContainerMain">
       
       <AnimatedWrapper delay={.4}>
        <Container className="downloadContainer">
           <Row className="downloadappContainer">
           
           
              <Container style={{display:'grid',placeItems:'center',width:'100%'}} >
            <Tabs
          defaultActiveKey="rider"
          id="justify-tab-example"
          className="mb-3 downloadtab"
          justify
        >
            <Tab  eventKey="rider" title="Rider">
            <Container fluid>
              <div style={{textAlign:'center',justifyContent:'center',alignItems:'center'}}>
                <h2 className="downloadheader"><strong>Book a Ride in Seconds, Enjoy Effortless Travel</strong></h2>
                <p className="downloadtext">
                Experience the convenience of Lodapoint's ride-hailing services. Connect with reliable 
                drivers and get to your destination quickly and safely. Join THE 
                LODA today and travel with peace of mind.
                </p>
              </div>
              <br/>

              <div className="buttoncontainer">
            <Button
                variant="primary"

                href={Links.User.playStore}
                target="_blank"
                 rel="noopener noreferrer"

                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  borderRadius: 36 + "px",
                   paddingTop:7+'px',
                  
                
                }}
                className="buttondownload"
                size="sm"
              >
               <PlayStoreSvg />
              </Button>
               <Button
                variant="primary"

               href={Links.User.appStore}
                target="_blank"
                 rel="noopener noreferrer"

                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  color: "#FFFFF",
                  borderRadius: 36 + "px",
                   paddingTop:7+'px'
                
                }}
                className="buttondownload"
                size="sm"
              >
               <AppStoreSvg />

              </Button>
            </div>
             
              
              </Container>
           
          </Tab>

          <Tab  eventKey="shipper" title="Sender">
            <Container fluid>
              <div style={{textAlign:'center',justifyContent:'center',alignItems:'center'}}>
                <h2 className="downloadheader"><strong>Request in Seconds, Load in Minutes</strong></h2>
                <p className="downloadtext">
                Simplify your logistics operations with Lodapoint's comprehensive shipping 
                solutions. Access a variety of transport options and streamline your supply chain 
                effortlessly. Join Lodapoint today and enjoy seamless shipping like never before.
                </p>
              </div>
              <br/>

              <div className="buttoncontainer">
            <Button
                variant="primary"

                 href={Links.User.playStore}
                target="_blank"
                 rel="noopener noreferrer"

                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  borderRadius: 36 + "px",
                   paddingTop:7+'px'
                
                }}
                className="buttondownload"
                size="sm"
              >
               <PlayStoreSvg />
              </Button>
               <Button
                variant="primary"

                href={Links.User.appStore}
                target="_blank"
                 rel="noopener noreferrer"

                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  color: "#FFFFF",
                  borderRadius: 36 + "px",
                   paddingTop:7+'px'
                
                }}
                className="buttondownload"
                size="sm"
              >
              <AppStoreSvg />
              </Button>
            </div>
             
              
              </Container>
           
          </Tab>

        

          <Tab  eventKey="driver" title="Driver">
            <Container fluid>
              <div style={{textAlign:'center',justifyContent:'center',alignItems:'center'}}>
                <h2 className="downloadheader"><strong>Drive Smart, Earn More</strong></h2>
                <p className="downloadtext">
                Empower your driving career with Lodapoint’s flexible opportunities. Maximize 
                your earnings while enjoying the freedom to choose your own schedule. Join THE 
                LODA today and take control of your driving journey.
                </p>
              </div>
              <br/>

              <div className="buttoncontainer">
            <Button
                variant="primary"

               href={Links.Driver.playStore}
                target="_blank"
                 rel="noopener noreferrer"

                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  borderRadius: 36 + "px",
                   paddingTop:7+'px'
                
                }}
                className="buttondownload"
                size="sm"
              >
               <PlayStoreSvg />
              </Button>
               <Button
                variant="primary"

                 href={Links.Driver.appStore}
                target="_blank"
                 rel="noopener noreferrer"

                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  color: "#FFFFF",
                  borderRadius: 36 + "px",
                   paddingTop:7+'px'
                
                }}
                className="buttondownload"
                size="sm"
              >
               <AppStoreSvg />

              </Button>
            </div>
             
              
              </Container>
           
          </Tab>

          <Tab eventKey="transporter" title="Transporter">
          <Container fluid>
              <div style={{textAlign:'center',justifyContent:'center',alignItems:'center'}}>
                <h2 className="downloadheader"><strong>Streamline Your Fleet, Boost Your Business</strong></h2>
                <p className="downloadtext">
                Optimize your transportation operations with Lodapoint's extensive network. 
                Gain access to diverse shipping requests and enhance your efficiency. Join Lodapoint
                today and elevate your fleet management like never before.
                </p>
              </div>
              <br/>

              <div className="buttoncontainer">
            <Button
                variant="primary"

                 href={Links.Transporter.playStore}
                target="_blank"
                 rel="noopener noreferrer"

                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  borderRadius: 36 + "px",
                   paddingTop:7+'px'
                
                }}
                className="buttondownload"
                size="sm"
              >
                <PlayStoreSvg />
              </Button>
               <Button
                variant="primary"

                 href={Links.Transporter.appStore}
                target="_blank"
                 rel="noopener noreferrer"
                style={{
                  backgroundColor: "#F36F2E",
                  borderColor: "#313434",
                  color: "#FFFFF",
                  borderRadius: 36 + "px",
                  paddingTop:7+'px'
                
                }}
                className="buttondownload"
                size="sm"
              >
              <AppStoreSvg />

              </Button>
            </div>
             
              
              </Container>

          </Tab>
          
        </Tabs>
        </Container>
      
           
           </Row>
        </Container>
        </AnimatedWrapper>
    </Container>
      
    
  )
}

export default DownloadApp ;
